const audioTitle = "_35sasdf2ke";
const audio = "_35sa1aaxzro";
const audioPlayer = "_35sawsztgv";

export { audio, audioPlayer, audioTitle };
import "./atom.audio.style.linaria.module.css";
//# sourceMappingURL=atom.audio.style.js.map
